import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchEmpresaColaboradoraData = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/empresa-colaboradora/${id}`, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEmpresasColaboradorasData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/empresas-colaboradoras`, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEmpresasColaboradorasFiltersData = async (paginaActual, registrosPorPag, busqueda, ordenarColumna, orden) => {
    try {
        const response = await axios.post(`${API_URL}/api/empresas-colaboradoras/filters`, {
            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "order": {
                "orderColumn": ordenarColumna || "",
                "order": orden || ""
            }
        }, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchCrearEmpresaColaboradora = async (formData) => {
    try {
        const response = await axios.post(`${API_URL}/api/empresa-colaboradora`, formData, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEditarEmpresaColaboradora = async (empresaData) => {
    try {
        const response = await axios.put(`${API_URL}/api/editarEmpresaColaboradora/${empresaData.get('Id')}`, empresaData, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEliminarEmpresasColaboradoras = async (ids) => {
    try {
        const idsArray = ids.toString().split(',');
        const promises = idsArray.map(id => axios.delete(`${API_URL}/api/empresa-colaboradora/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        }));
        const responses = await Promise.all(promises);
        const response = { data: responses.map(res => res.data) };
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};
